"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { ArtistActivityBadge } from "@/components/waves/drops/ArtistActivityBadge";
import { useArtistPreviewModal } from "@/hooks/useArtistPreviewModal";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { getSubmissionCount, getTrophyArtworkCount } from "@/helpers/artist-activity.helpers";
interface MemeDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
export default function MemeDropArtistInfo(t0) {
  const $ = _c(41);
  const {
    drop
  } = t0;
  const {
    isModalOpen,
    modalInitialTab,
    handleBadgeClick,
    handleModalClose
  } = useArtistPreviewModal();
  const submissionCount = getSubmissionCount(drop.author);
  const hasSubmissions = submissionCount > 0;
  const trophyCount = getTrophyArtworkCount(drop.author);
  const hasTrophyArtworks = trophyCount > 0;
  const hasActivityBadge = hasSubmissions || hasTrophyArtworks;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop.author) {
    t2 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[2] = drop.author;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `/${drop.author?.handle}`;
  let t4;
  if ($[4] !== drop.author) {
    t4 = drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><span className="tw-mb-0 tw-text-md tw-font-semibold tw-leading-none">{drop.author?.handle}</span></UserProfileTooltipWrapper> : <span className="tw-mb-0 tw-text-md tw-font-semibold tw-leading-none">{drop.author?.handle}</span>;
    $[4] = drop.author;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Link href={t3} onClick={_temp} className="tw-no-underline">{t4}</Link>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== drop.id || $[10] !== handleBadgeClick || $[11] !== hasActivityBadge || $[12] !== submissionCount || $[13] !== trophyCount) {
    t6 = hasActivityBadge && <ArtistActivityBadge submissionCount={submissionCount} trophyCount={trophyCount} onBadgeClick={handleBadgeClick} tooltipId={`meme-activity-badge-${drop.id}`} />;
    $[9] = drop.id;
    $[10] = handleBadgeClick;
    $[11] = hasActivityBadge;
    $[12] = submissionCount;
    $[13] = trophyCount;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-size-[3px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-600" />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== drop.created_at) {
    t8 = <WaveDropTime timestamp={drop.created_at} />;
    $[16] = drop.created_at;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = drop.winning_context?.decision_time ?? null;
  let t10;
  if ($[18] !== drop.rank || $[19] !== t9) {
    t10 = <div className="tw-ml-2"><WinnerDropBadge rank={drop.rank} decisionTime={t9} /></div>;
    $[18] = drop.rank;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2 || $[23] !== t5 || $[24] !== t6 || $[25] !== t8) {
    t11 = <div className="tw-flex tw-items-center tw-gap-x-2">{t2}{t5}{t6}{t7}{t8}{t10}</div>;
    $[21] = t10;
    $[22] = t2;
    $[23] = t5;
    $[24] = t6;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== drop.wave) {
    t12 = drop.wave && <Link onClick={_temp2} href={getWaveRoute({
      waveId: drop.wave.id,
      isDirectMessage: false,
      isApp: false
    })} className="tw-leading-0 tw-mb-0 tw-text-[11px] tw-text-iron-500 tw-no-underline tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-300">{drop.wave.name}</Link>;
    $[27] = drop.wave;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <div className="tw-flex tw-flex-col tw-gap-y-1.5">{t11}{t12}</div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== drop.author || $[33] !== handleModalClose || $[34] !== isModalOpen || $[35] !== modalInitialTab) {
    t14 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[32] = drop.author;
    $[33] = handleModalClose;
    $[34] = isModalOpen;
    $[35] = modalInitialTab;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t1 || $[38] !== t13 || $[39] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-gap-x-3">{t1}{t13}{t14}</div>;
    $[37] = t1;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}